import { render, staticRenderFns } from "./BasemapsModal.vue?vue&type=template&id=2f2ce218&scoped=true&"
import script from "./BasemapsModal.vue?vue&type=script&lang=js&"
export * from "./BasemapsModal.vue?vue&type=script&lang=js&"
import style0 from "./BasemapsModal.vue?vue&type=style&index=0&id=2f2ce218&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f2ce218",
  null
  
)

export default component.exports